/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import Step from '../../forms/step';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import { isEmpty } from 'lodash';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';
import {
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  AddBox,
  StyledCrudTable,
  Steps,
} from './styles';

const SelectStepDialogControl = ({
  data,
  className,
  id,
  enabled,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible,
  disabled,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [selectedStep, setSelectedStep] = React.useState({});
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const columns = Step.tableSchema;
  const ignoreList =
    config.completeData?.workflows?.map((x) => x?.stepId) ?? [];

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    restApiClient.step
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('name', searchBy)
              .or()
              .like('section.name', searchBy)
              .or()
              .like('section.parent.name', searchBy)
              .or()
              .like('section.parent.parent.name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.step.findById(data).then((e) => {
        setSelectedStep(e.data);
      });
    } else {
      setSelectedStep({});
    }
  }, [data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<Steps />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label="Etapa"
          InputLabelProps={{
            shrink: true,
            readOnly: true,
          }}
          value={selectedStep?.name ?? ''}
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
        >
          <DialogContent>
            <StyledCrudTable
              title={'Seleção de Etapa'}
              modelActions={Step.actions}
              columns={columns}
              rows={rows}
              page={page}
              setPage={(page) => setPage(page)}
              rowsPerPage={rowsPerPage}
              availableRowsPerPage={[3]}
              setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
              onOrderByChange={(orderBy) => setOrderby(orderBy)}
              orderBy={orderBy}
              setOrderBy={(value) => setOrderby(value)}
              searchBy={searchBy}
              setSearchBy={(value) => setSearchBy(value)}
              actions={{
                insert: {
                  icon: <AddBox />,
                  onClick: (id, data) => {
                    setSelectedStep(data);
                    handleChange?.(path, id);
                    onSuccess?.(id);
                    handleClose();
                  },
                  title: 'Vincular',
                  allowedActions: [Step.actions.getAll],
                  selector: (row) => !ignoreList.includes(row.id),
                },
              }}
              customCellRenderers={{
                section: {
                  renderer: (field, value) => {
                    if (value?.parent) {
                      if (value.parent?.parent) {
                        return ` ${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
                      } else {
                        return `${value.parent.name} > ${value.name}`;
                      }
                    } else {
                      return value.name;
                    }
                  },
                },
                price: {
                  renderer: (field, value) => {
                    value = parseFloat(value);
                    return value.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    });
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Hidden>
  );
};

export default SelectStepDialogControl;
